import React from "react";
import "../auth/login.css";
import "../../common/fonts/fonts.css";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import axiosInstance from "../../services/axios";
import { useNavigate } from "react-router-dom";
function Signup(){
    // const toast = useToast();
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
      } = useForm();
    
      const onSubmit = async (values)=>{
        try{
         await axiosInstance.post("/users/create", values);
         navigate("/login",{replace:true});
        }
        catch (err){
            console.log(err)
            console.log(values)            

        }

      };

    return(
        <div className="loginWrapper">
        <div className="leftCol">
            <div className="content">
                <img src={process.env.PUBLIC_URL +'img/bedater-logo.png' } alt="" title="" width="86" />
                <h1>Sign Up</h1>
                <p className="mb-0">Create your account.</p>
            </div>
            <div className="graphicImg">
                <img src={process.env.PUBLIC_URL +'img/login-debaters-img.png' } alt="" title="" />
            </div>
        </div>
        <div className="rightCol">
            <div className="accountTxt">
                Already have an Account? <Link to="/login">Login</Link>
            </div>
            <div className="form">
                <form className="mb-0" onSubmit={handleSubmit(onSubmit)} action="#">
                    <div className="form-group">
                        <label htmlFor="inputUsername">Username</label>
                        <input type="text" name="username" className="form-control" id="inputUsername"
                            placeholder="Enter username"  {...register("username", {
                                required: "This is required field",
                              })}
                            />
                        <small className="form-text invalid-feedback">We'll never share your email
                            with anyone else.</small>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputName">Name</label>
                        <input type="text" name="name" className="form-control" id="inputName" placeholder="Enter your name"
                        {...register("name", {
                            required: "This is required field",
                          })}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputEmail">Email</label>
                        <input type="email" name="email" className="form-control" id="inputEmail" placeholder="Enter your email"
                         {...register("email", {
                            required: "This is required field",
                          })}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputPhone">Phone Number</label>
                        <input type="text" name="phone" className="form-control" id="inputPhone" placeholder="Enter your phone number"
                         {...register("phone_no", {
                            required: "This is required field",
                          })}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputPassword">Password</label>
                        <input type="password" name="password" className="form-control" id="inputPassword"
                            placeholder="Enter your password"
                            {...register("password", {
                                required: "This is required field",
                              })}    
                        />
                    </div>
                    <div>
                        <small>By clicking Sign Up, you agree to our Terms, Data Policy and Cookie Policy. </small>
                    </div>
                    
                   
                    <button className="btn btn-secondary w-100" type="submit">Sign Up</button>
                </form>
            </div>
        </div>
    </div>
    );
}

export default Signup;